import DriverPartnerQrPanel from "@/components/mobile/DriverPartnerQrPanel";

/** /dd/scan — show partner join QR (others scan with their phone). */
export default function DriverPartnerScan() {
  return (
    <DriverPartnerQrPanel
      title="Delivery partner QR"
      hint="Show this QR. New partner scans with their phone camera to open the Delivery app and sign up."
      onJoin={() => {
        window.location.assign(`${window.location.origin}/dd/join`);
      }}
    />
  );
}
